<template>
  <div class="assistant-wrapper" 
    ref="assistantWrapper"
    :style="{ 
      left: isDragged ? wrapperLeft + 'px' : initialPercent.left + '%', 
      top: isDragged ? wrapperTop + 'px' : initialPercent.top + '%' 
    }">
    <!-- 触发按钮 - 使用新样式 -->
    <div
    class="assistant-trigger"
      @click="toggleAssistant"
      ref="assistantTrigger"
      @mousedown="startDrag"
    >
      <div class="ai-button-inner">
        <div class="ai-avatar">
          <div class="smile-icon">
            <img src="../assets/image/AI-chat.png" class="AIimg" alt="" />
          </div>
        </div>
        <span class="ai-text">AI助手</span>
      </div>
    </div>

    <!-- AI助手面板，显示在按钮左侧 -->
    <div
      v-show="showAssistant"
      class="ai-assistant-panel"
      :style="panelPosition"
    >
      <!-- 面板头部 - 新样式 -->
      <div class="panel-header">
        <div class="header-content">
          <div class="header-avatar">
            <!-- <img src="../assets/image/AI-chat.png" class="AIimg" alt="" /> -->
            <img src="../../public/1705389610070.jpg" class="AIimg" alt="" />
          </div>
          <div class="header-title">
            <h3>AI助手</h3>
            <!-- <div class="status-indicator">
              <span class="online-dot"></span>
              <span class="status-text">在线</span>
            </div> -->
          </div>
        </div>
        <div class="header-actions">
          <!-- 添加刷新点击事件 -->
          <i class="el-icon-refresh" @click="resetConversation"></i>
          <i class="el-icon-close" @click="showAssistant = false"></i>
        </div>
      </div>

      <!-- 消息区域 -->
      <div class="message-container" ref="messageContainer">
        <!-- 背景装饰元素 -->
        <div class="background-decoration">
          <div class="decor-element"></div>
          <div class="decor-element"></div>
          <div class="decor-element"></div>
        </div>

        <!-- 欢迎消息 -->
        <div v-if="messages.length === 0" class="welcome-section">
          <div class="welcome-message">
            <p>
              你好呀～ 我是 AI 助手，很荣幸能为您提供服务呢～😊
              您是想了解我们的产品吗？像
              <strong>弹性云服务器、高防服务器</strong> 或者
              <strong>游戏盾</strong>
              这些，都可以跟我说说是哪方面的需求，我来为您详细介绍哦～
            </p>
          </div>

          <!-- 服务特点提示 -->
          <div class="service-features">
            <div class="feature-item">
              <i class="el-icon-check-circle"></i>
              <span>7×24小时在线支持</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check-circle"></i>
              <span>专业技术团队</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check-circle"></i>
              <span>定制化解决方案</span>
            </div>
          </div>

          <!-- 产品类别标签 -->
          <div class="product-tags">
            <span class="tag">云服务器</span>
            <span class="tag">安全防护</span>
            <span class="tag">数据存储</span>
            <span class="tag">网络加速</span>
          </div>
        </div>
        <!-- 消息列表 -->

        <div
          v-for="(msg, index) in messages"
          :key="index"
          :class="['message-item', msg.isUser ? 'user-message' : 'ai-message']"
        >
          <div class="avatar">
            <div v-if="!msg.isUser" class="ai-avatar-chat">
              <img src="../../public/1705389610070.jpg" class="AIimg" alt="" />
            </div>
            <img
              v-if="msg.isUser"
              class="ai-avatar-chat"
              src="../assets/image/u=3061155316,329340046&fm=253&fmt=auto&app=138&f=JPEG.webp"
              alt="用户头像"
            />
          </div>
          <div class="message-content">
            <div
              v-if="!msg.isLoading"
              v-html="formatParagraph(msg.content)"
            ></div>
            <div v-if="msg.isLoading" class="loading-indicator">
              <span>思考中</span>
              <span class="dot"> 。 </span>
              <span class="dot"> 。 </span>
              <span class="dot"> 。 </span>
            </div>

            <!-- AI回复后的操作按钮 - 仅在AI消息且加载完成后显示 -->
            <div v-if="!msg.isUser && aibtnType" class="message-actions">
              <!-- 售前售后按钮 -->
              <div class="service-buttons">
                <el-button
                  type="text"
                  class="pre-sales"
                  @click="handlePreSales"
                >
                  <i class="el-icon-headset"></i> 售前
                </el-button>
                <el-button
                  type="text"
                  class="after-sales"
                  @click="handleAfterSales"
                >
                  <i class="el-icon-service"></i> 售后
                </el-button>
              </div>

              <!-- 复制、点赞、点踩按钮 -->
              <div class="interaction-buttons">
                <el-button
                  type="text"
                  icon="el-icon-document-copy"
                  @click="copyToClipboard(msg.content)"
                  >复制</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-thumb"
                  @click="handleLike(index)"
                  :class="{ liked: msg.liked }"
                  >点赞</el-button
                >
              </div>
            </div>
            <div v-if="!msg.isUser && aibtnType">
              <div v-for="(item, qIndex) in msg.relatedQuestions" :key="qIndex">
                <span class="associateSpan" @click="clickChatList(item)">{{
                  item
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 快捷问题 -->
        <h4 class="quick-questions" v-if="showQuickQuestions">相关搜索</h4>
        <div class="quick-questions" v-if="showQuickQuestions">
          <el-button
            v-for="(question, qIndex) in quickQuestionList"
            :key="qIndex"
            type="text"
            @click="handleQuickQuestion(question)"
          >
            {{ question }}
          </el-button>
        </div>
      </div>

      <!-- 输入区域 -->
      <div class="input-container">
        <el-input
          v-model="inputMessage"
          placeholder="您可以用“产品+问题”的形式描述问题～"
          @keyup.enter.native="sendMessage"
          :disabled="isLoading"
          class="custom-input"
        ></el-input>
        <el-button
          type="primary"
          @click="sendMessage"
          :loading="isLoading"
          icon="el-icon-s-promotion"
          class="send-button"
        ></el-button>
      </div>

      <!-- 底部提示 -->
      <div class="footer-tip">
        内容由AI生成，仅供参考，您据此所作判断及操作均由您自行承担责任。
      </div>
    </div>
  </div>
</template>

<script>
import { GetAiChatStream, GetAiChat } from "../api/user";
import { log } from 'three';
export default {
  name: "AiAssistantPanel",
  data() {
    return {
      showAssistant: false,
      messages: [],
      inputMessage: "",
      isLoading: false,
      panelPosition: {},
      showQuickQuestions: true,
      quickQuestionList: [
        "需要了解公司有哪些产品",
        "物理服务器有哪些型号？",
        "服务器租用价格包含哪些服务？？",
        "云服务器有哪些套餐、配置、以及费用问题？",
      ],
      aibtnType: false,
      chatList: [],
      // 拖拽相关变量
      isDragging: false,
      startX: 0,
      startY: 0,
      initialPercent: {
        left: 96,  // 85% 靠右
        top: 66   // 70% 靠下
      },
      isDragged: false,  // 是否被拖拽过（区分百分比/像素定位）
      wrapperLeft: 1600,  // 初始位置
      wrapperTop: 600,
      triggerWidth: 0,
      triggerHeight: 0,
      panelWidth: 600,
      panelHeight: 700,
      observedPanelWidth: 600,
      observedPanelHeight: 700
    };
  },
  // 监听窗口大小变化，重新计算面板位置
  mounted() {
     // 初始化时无需额外计算（直接用CSS百分比）
     this.$nextTick(() => {
      this.calculatePanelPosition();
    });
    
    // 窗口 resize 时，若未拖拽过，保持百分比定位（自动适应）
    window.addEventListener('resize', () => {
      if (!this.isDragged && this.showAssistant) {
        this.calculatePanelPosition();
      }
    });
  },
  methods: {
   // 开始拖拽
   startDrag(e) {
      if (e.button !== 0) return;
      e.preventDefault();
      
      // 获取当前按钮位置（如果是百分比定位，先转成像素）
      const rect = this.$refs.assistantWrapper.getBoundingClientRect();
      this.startX = e.clientX - rect.left;  // 修正拖拽起点
      this.startY = e.clientY - rect.top;
      
      this.isDragging = true;
      document.addEventListener('mousemove', this.handleDrag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    handleDrag(e) {
      if (!this.isDragging) return;
      
      // 拖拽时强制用像素定位
      const trigger = this.$refs.assistantTrigger;
      const maxLeft = window.innerWidth - trigger.offsetWidth;
      const maxTop = window.innerHeight - trigger.offsetHeight;
      
      // 计算新位置（限制在屏幕内）
      this.wrapperLeft = Math.max(0, Math.min(maxLeft, e.clientX - this.startX));
      this.wrapperTop = Math.max(0, Math.min(maxTop, e.clientY - this.startY));
      this.isDragged = true;  // 标记为已拖拽（切换到像素定位）
      
      if (this.showAssistant) {
        this.calculatePanelPosition();
      }
    },
    
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.handleDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    
    // 切换助手显示隐藏
    toggleAssistant() {
      this.showAssistant = !this.showAssistant;
      if (this.showAssistant) {
        this.calculatePanelPosition();
      }
    },
    
    // 计算面板位置
    calculatePanelPosition() {
      const trigger = this.$refs.assistantTrigger;
      if (!trigger) return;
      
      // 获取触发按钮和面板的实际尺寸
      const triggerRect = trigger.getBoundingClientRect();
      const panelRect = this.$refs.assistantPanel?.getBoundingClientRect();
      
      // 实时更新面板尺寸（应对动态内容导致的尺寸变化）
      this.observedPanelWidth = panelRect?.width || this.panelWidth;
      this.observedPanelHeight = panelRect?.height || this.panelHeight;
      
      // 屏幕中心参考点
      const screenCenterX = window.innerWidth / 2;
      const screenCenterY = window.innerHeight / 2;
      
      // 判断按钮在屏幕的左右半区
      const isOnLeft = (triggerRect.left + triggerRect.width / 2) < screenCenterX;
      
      // 水平位置计算（左则右显，右则左显）
      let left;
      if (isOnLeft) {
        left = triggerRect.width + 10;
        // 检查右侧是否超出屏幕
        const rightEdge = triggerRect.left + left + this.observedPanelWidth;
        if (rightEdge > window.innerWidth) {
          left = -this.observedPanelWidth - 10; // 强制显示在左侧
        }
      } else {
        left = -this.observedPanelWidth - 10;
        // 检查左侧是否超出屏幕
        if (triggerRect.left + left < 0) {
          left = triggerRect.width + 10; // 强制显示在右侧
        }
      }
      
      // 垂直位置计算（优先保证完整显示）
      let top;
      // 计算两种可能的显示位置：按钮下方和按钮上方
      const showBelowTop = 0;
      const showBelowBottom = triggerRect.top + showBelowTop + this.observedPanelHeight;
      const showAboveTop = -this.observedPanelHeight;
      const showAboveBottom = triggerRect.top + showAboveTop + this.observedPanelHeight;
      
      // 检测两种位置是否会超出屏幕
      const canShowBelow = showBelowBottom <= window.innerHeight;
      const canShowAbove = showAboveTop + triggerRect.top >= 0;
      
      // 优先选择能完整显示的位置
      if (canShowBelow) {
        top = showBelowTop; // 显示在下方
      } else if (canShowAbove) {
        top = showAboveTop; // 显示在上方
      } else {
        // 两种位置都不能完整显示时，选择超出较少的方向
        const belowOverflow = showBelowBottom - window.innerHeight;
        const aboveOverflow = 0 - (triggerRect.top + showAboveTop);
        
        if (belowOverflow <= aboveOverflow) {
          // 下方超出较少，向上调整
          top = showBelowTop - belowOverflow;
        } else {
          // 上方超出较少，向下调整
          top = showAboveTop + aboveOverflow;
        }
      }
      
      this.panelPosition = {
        left: `${left}px`,
        top: `${top}px`
      };
    },

    // 重置对话到初始状态
    resetConversation() {
      // 清空消息列表
      this.messages = [];
      // 清空输入框
      this.inputMessage = "";
      // 隐藏加载状态
      this.isLoading = false;
      // 显示快捷问题
      this.showQuickQuestions = true;
      // 滚动到顶部
      this.$nextTick(() => {
        const container = this.$refs.messageContainer;
        if (container) {
          container.scrollTop = 0;
        }
      });
    },

    // 发送消息
    async sendMessage() {
      this.getaichat();
      if (!this.inputMessage.trim() || this.isLoading) return;

      // 添加用户消息
      const userMessage = {
        content: this.inputMessage,
        isUser: true,
        isLoading: false,
        liked: false,
      };
      this.messages.push(userMessage);
      // this.inputMessage = "";
      this.scrollToBottom();
      this.showQuickQuestions = false; // 发送消息后隐藏快捷问题
      this.aibtnType = false; //复制等按钮隐藏

      // 显示加载状态：只创建1条"思考中"消息（删除原重复的loadingMsg）
      this.isLoading = true;
      const aiMessage = {
        content: "",
        isUser: false,
        isLoading: true, // 初始为"思考中"状态
        liked: false,
        relatedQuestions: [],
      };
      this.messages.push(aiMessage);
      this.scrollToBottom();

      // 记录这条AI消息在数组中的索引（现在只有1条，索引是messages.length - 1）
      const msgIndex = this.messages.length - 1;
      // 👇 关键修改：调用getaichat时，传入当前AI消息的索引，让接口返回的问题存入这条AI消息
      this.getaichat(msgIndex);

      let eventSource = new EventSource(
        `https://caiwu.yxtidc.com/api/ai/chat/streams?data=${
          this.inputMessage
        }&hideLoading=${false}`
      );

      eventSource.onmessage = (event) => {
        // console.log(event.data);

        // AI开始返回内容时：1.关闭"思考中" 2.拼接回答内容
        this.messages[msgIndex].isLoading = false; // 关键：隐藏思考中
        this.messages[msgIndex].content += event.data; // 拼接流式返回的内容
        this.scrollToBottom(); // 滚动到最新内容
      };

      eventSource.onerror = () => {
        this.aibtnType = true;
        console.log("EventSource failed");
        // 出错时更新消息状态
        this.messages[msgIndex].isLoading = false;
        this.isLoading = false;
        this.inputMessage = "";
        eventSource.close();
        this.scrollToBottom(); // 滚动到最新内容
      };
      
      eventSource.onopen = () => {
        console.log("Connection opened");
      };

      // 连接关闭时恢复加载状态（可选，防止按钮一直loading）
      eventSource.onclose = () => {
        this.isLoading = false;
      };

      return;
    },

    // 相关问题接口
    async getaichat(msgIndex) {
      // console.log(msgIndex);
      // 若没传msgIndex（初始调用时），直接返回，避免报错
      if (msgIndex === undefined) return;

      let data = await GetAiChat({ data: this.inputMessage });
      if (data.code == 200) {
        console.log(data);
        // 把相关问题存入指定AI消息的relatedQuestions
        this.messages[msgIndex].relatedQuestions = data.data;
        // this.aibtnType = false
      } else {
        this.$message.error(data.msg);
      }
    },

    // 处理快捷问题点击
    handleQuickQuestion(question) {
      this.inputMessage = question;
      this.sendMessage();
    },

    // 滚动到最新消息
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    // 新增：售前按钮点击事件
    handlePreSales() {
      window.open("https://yxtidc.com/", "_blank");
    },

    // 新增：售后按钮点击事件
    handleAfterSales() {
      window.open("https://yxtidc.com/", "_blank");
    },

    // 新增：复制到剪贴板
    copyToClipboard(content) {
      // 创建一个临时元素用于复制
      const tempElement = document.createElement("div");
      tempElement.innerHTML = content;
      document.body.appendChild(tempElement);

      // 创建选中范围
      const range = document.createRange();
      range.selectNode(tempElement);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      // 执行复制命令
      try {
        document.execCommand("copy");
        this.$message.success("复制成功");
      } catch (err) {
        this.$message.error("复制失败，请手动复制");
      } finally {
        // 清理临时元素和选中范围
        window.getSelection().removeAllRanges();
        document.body.removeChild(tempElement);
      }
    },

    // 新增：点赞功能
    handleLike(index) {
      // 切换点赞状态，取消点踩状态
      this.messages[index].liked = !this.messages[index].liked;
    },
    clickChatList(e) {
      console.log(e);
      this.inputMessage = e;
      this.sendMessage();
    },
    formatParagraph(text) {
      if (!text) return ""; // 处理空文本，避免报错

      // 第一步：将 **内容** 转成 <strong>内容</strong>（实现加粗）
      // 正则说明：/(\*\*)(.*?)\1/g 匹配成对的 **，.*? 匹配中间的内容（非贪婪模式，避免多对**冲突）
      const boldText = text.replace(/(\*\*)(.*?)\1/g, "<strong>$2</strong>");

      // 第二步：按之前的逻辑处理换行（\n\n 分段落，\n 转换行）
      return boldText
        .split(/\n\n+/) // 按 1个以上的\n 分割成段落
        .filter((para) => para.trim()) // 过滤空段落（避免多余空行）
        .map((para) => `<p>${para.replace(/\n/g, "<br>")}</p>`) // 段落内的\n 转 <br>
        .join("");
    },
  },
  
};
</script>

<style scoped>
.assistant-wrapper {
  position: fixed;
  z-index: 9999;
  /* 移除原有固定定位 */
  bottom: auto;
  right: auto;
}

/* 新的AI助手按钮样式 */
.assistant-trigger {
  width: 55px;
  height: 55px;
  cursor: pointer;
}

.ai-button-inner {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #1d42ab, #2173dc, #1e93ff);
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(64, 158, 255, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.ai-button-inner:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.5);
}

.smile-icon {
  font-size: 24px;
}

.ai-text {
  color: white;
  font-size: 10px;
  font-weight: 500;
}

/* AI助手面板样式 - 新设计 */
.ai-assistant-panel {
  position: absolute;
  top: -850%;
  left: -950%;
  width: 600px;
  min-height: 700px;
  max-height: 700px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
}

/* 面板头部样式 */
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background: linear-gradient(90deg, #1d42ab, #2173dc, #1e93ff);
  color: white;
}

.header-content {
  display: flex;
  align-items: flex-end;
}

.header-avatar {
  width: 32px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-right: 12px;
}
.AIimg {
  width: 25px;
  height: 25px;
}

.header-title h3 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
}

.status-indicator {
  display: flex;
  align-items: center;
  font-size: 12px;
  opacity: 0.9;
}

.online-dot {
  width: 8px;
  height: 8px;
  background-color: #4caf50;
  border-radius: 50%;
  margin-right: 4px;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.header-actions i {
  cursor: pointer;
  font-size: 16px;
  opacity: 0.9;
  transition: opacity 0.2s;
}

.header-actions i:hover {
  opacity: 1;
}

/* 消息区域 */
.message-container {
  flex: 1;
  overflow-y: auto;
  padding: 15px 18px;
  max-height: 480px;
  min-height: 480px;
  background-color: #fafafa;
}
/* 背景装饰 */
.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.decor-element {
  position: absolute;
  border-radius: 50%;
  opacity: 0.05;
  background: #409eff;
}

.decor-element:nth-child(1) {
  width: 200px;
  height: 200px;
  top: 10%;
  right: 5%;
}

.decor-element:nth-child(2) {
  width: 150px;
  height: 150px;
  bottom: 20%;
  left: 10%;
  background: #67c23a;
}

.decor-element:nth-child(3) {
  width: 100px;
  height: 100px;
  top: 40%;
  left: 20%;
  background: #f56c6c;
}

/* 欢迎区域 */
.welcome-section {
  position: relative;
  z-index: 1;
}
.welcome-message {
  font-size: 16px;
  line-height: 1.6;
  color: #374151;
  margin-bottom: 25px;
  margin-top: 10px;
  padding: 15px;
  background-color: #f0f9ff;
  border-radius: 12px;
  border-left: 4px solid #3b82f6;
  border-right: 4px solid #3b82f6;
}

.welcome-message strong {
  color: #1e40af;
}
/* 服务特点 */
.service-features {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 15px;
  margin-bottom: 40px;
}

.feature-item {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #eaecf0;
  border-radius: 8px;
  color: #1e40af;
  font-size: 14px;
  transition: all 0.2s ease;
}

.feature-item:hover {
  transform: translateX(5px);
}

.feature-item i {
  color: #10b981;
}

/* 产品标签 */
.product-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 12px;
  margin-bottom: 40px;
}

.tag {
  padding: 8px 16px;
  background-color: #3b82f6;
  border-radius: 20px;
  font-size: 14px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tag:hover {
  background-color: #3b82f6;
  color: white;
  transform: scale(1.05);
}

.message-item {
  display: flex;
  margin-bottom: 18px;
  max-width: 100%;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-message {
  flex-direction: row-reverse;
  justify-content: flex-start;
}

.avatar {
  display: flex;
  align-items: flex-start;
  margin-right: 10px;
  flex-shrink: 0;
}

.ai-avatar-chat {
  width: 36px;
  height: 36px;
  background-color: #e6f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #1890ff;
}

.user-avatar {
  font-size: 36px;
  color: #1890ff;
}

.user-message .avatar {
  margin-right: 0;
  margin-left: 10px;
}

.message-content {
  max-width: 80%;
  padding: 10px 15px;
  border-radius: 14px;
  line-height: 1.6;
  font-size: 14px;
  word-break: break-word;
}

.ai-message .message-content {
  background-color: white;
  color: #333;
  /* border: 1px solid #e5e7eb; */
  border-top-left-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.user-message .message-content {
  background-color: #1890ff;
  color: #fff;
  border-top-right-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.loading-indicator {
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  color: #333;
}
.dot {
  /* 点的样式和动画 */
  animation: bounce 1.4s infinite ease-in-out both;
  display: inline-block;
  vertical-align: middle;
}

/* 为每个点设置不同的动画延迟 */
.dot:nth-child(2) {
  animation-delay: -0.32s;
}
.dot:nth-child(3) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.loading-indicator .el-loading-spinner {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

/* 快捷问题 */
.quick-questions {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 10px;
  padding: 0 20px;
}

.quick-questions .el-button {
  padding: 6px 12px;
  font-size: 13px;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  color: #666;
  background-color: white;
  transition: all 0.2s;
  margin: 0px;
}

.quick-questions .el-button:hover {
  background-color: #f5f7fa;
  color: #1890ff;
  border-color: #e6f7ff;
}

/* 输入区域 */
.input-container {
  display: flex;
  gap: 10px;
  padding: 12px 18px;
  border-top: 1px solid #e5e7eb;
  background-color: white;
}

.custom-input .el-input__inner {
  border-radius: 20px;
  padding: 10px 15px;
  border-color: #e5e7eb;
  transition: border-color 0.3s;
}

.custom-input .el-input__inner:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.send-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3b82f6;
  border-color: #3b82f6;
  transition: all 0.2s;
}

.send-button:hover {
  background-color: #0984e3;
  border-color: #0984e3;
  transform: scale(1.05);
}

/* 底部提示 */
.footer-tip {
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 10px 0;
  border-top: 1px solid #f3f4f6;
  background-color: #fafafa;
}

/* 消息操作按钮样式 */
.message-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

/* 售前售后按钮样式 */
.service-buttons {
  display: flex;
}

.service-buttons .pre-sales {
  color: #409eff;
}

.service-buttons .after-sales {
  color: #67c23a;
}

/* 互动按钮样式 */
.interaction-buttons {
  display: flex;
  gap: 5px;
}

.interaction-buttons .el-button {
  color: black;
}

.interaction-buttons .liked {
  color: #f56c6c;
}

.interaction-buttons .disliked {
  color: #606266;
}
.associateSpan {
  margin-top: 10px;
  display: inline-block;
  border: 1px solid #eef0f7;
  padding: 6px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  background-color: #fff;
}
.associateSpan:hover {
  color: #0984e3;
}
@media (max-width: 768px) {
  .assistant-wrapper {
    display: none;
  }
}
</style>
